import { createAction } from '@reduxjs/toolkit';

export const openDeliveryByEventModal = createAction<string>('deliveryByEvent/openModal');
